module.exports = __webpack_public_path__ + "img/qilin-f-stage2-sulking.371df413.png";